/**
 * `useApiClient` — a memoised {@link ApiClient} bound to the current user's
 * Firebase ID token. Feature hooks call this to get a token-injecting client
 * for TanStack Query queries/mutations; they never construct `fetch` calls or
 * the client by hand.
 */
import { useMemo } from "react";
import { createApiClient, type ApiClient } from "./client";
import { useIdToken } from "@/auth/AuthProvider";

export function useApiClient(): ApiClient {
  const getToken = useIdToken();
  return useMemo(() => createApiClient({ getToken }), [getToken]);
}
